// 계좌 관련 API 함수 (tb_accounts)
import axiosInstance from './axiosInstance';

// 계좌 목록 조회 (로그인한 사용자 기준)
export const fetchAccounts = async () => {
  const response = await axiosInstance.get('/accounts');
  return response.data.data;
};

// 계좌 등록
export const createAccount = async (payload) => {
  const response = await axiosInstance.post('/accounts', payload);
  return response.data;
};

// 계좌 수정
export const updateAccount = async (id, payload) => {
  const response = await axiosInstance.put(`/accounts/${id}`, payload);
  return response.data;
};

// 계좌 삭제
export const deleteAccount = async (id) => {
  const response = await axiosInstance.delete(`/accounts/${id}`);
  return response.data;
};
